// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2s71F","select":"Header_select__1wi2r","clinic":"Header_clinic__1Tkhj"};